// extracted by mini-css-extract-plugin
export default {"panel":"EmptyState_panel__MESUN","icon":"EmptyState_icon__OxatI"};